/** @jsx jsx */
import { jsx } from "theme-ui"
// import { graphql } from "gatsby"
import "../assets/scss/style.scss"
import "../styles.scss" // Import global styles

import Header from "./header"

import { Suspense, lazy } from "react"

const Footer = lazy(() => import("./footer"))

const Layout = ({ children, className = "" }) => {
  return (
    <div className="primary-container">
      <Header siteTitle={"Wyszukiwarka wakacji - Znajdź wakacje marzeń!"}>
        {/* <Logo title={siteTitle} /> */}
      </Header>
      <main className={"container " + className}>{children}</main>
      <Suspense fallback={<div>Loading...</div>}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default Layout
